import React from 'react';
import styled from 'styled-components';


const NotificationContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 16px;
  right: 16px;
  white-space: pre-line;
  z-index: ${(props) => props.zIndex || 400};
`;

const NotificationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background-color: ${(props) => {
    switch (props.type) {
      case "success":
        return "#0087CD";
      case "warning":
        return "#FFD100";
      case "error":
        return "#DC0A0A";
      default:
        return "#FFD100";
    }
  }};
  color: ${(props) => {
    switch (props.type) {
      case "success":
        return "white";
      case "warning":
        return "black";
      case "error":
        return "white";
      default:
        return "black";
    }
  }};
`;

const IconWrapper = styled.div`
  cursor: pointer;
  height: 20px;
  width: 20px;
  margin-left: 10px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconContainer = styled.div`
  width: 2%;
  height: 2%;
`;

const TextContainer = styled.div`
  flex-grow: 1;
  margin-left: 10px;
`;


class CustomNotification extends React.Component {
  render() {

    const { type, text, buttonElement, hideNotification } = this.props;

    let icon;

    switch (type) {
      case "success":
        icon = (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
              <path fill="currentColor" d="M576.8,661.2c-29.3,39.1-96.4,89.5-158.1,89.5c-19.6,0-34.7-21.1-34.7-30.1c0-8.3,3.1-17.3,9.2-32.4l78.3-187.4
                c2.2-6.1,2.2-10.5-1.5-10.5c-12.8,0-55,31.5-67.1,42.9c-9-1.5-15.1-11.4-12-18.1c40.7-49.6,111.5-86.5,151.4-86.5
                c16.6,0,34.6,16.5,34.6,33.1c0,7.5-5.3,21.8-9.7,33.1l-78.4,184.5c-3,6.8-2.3,11.2,3,11.2c10.5,0,51.9-29.3,70.8-47.4
                c8.1-0.1,14.7,6.4,14.7,14.5C577.3,658.8,577.1,660.1,576.8,661.2z M578.5,396.1c-33.9,0-61.4-27.5-61.4-61.5s27.5-61.4,61.5-61.4
                c33.9,0,61.4,27.5,61.4,61.4C640,368.6,612.5,396.1,578.5,396.1C578.6,396.1,578.6,396.1,578.5,396.1L578.5,396.1z"/>
              <path fill="currentColor" d="M512,171c188,0,341,153,341,341S700,853,512,853S171,700,171,512S324,171,512,171 M512,128c-211.8,0-384,172.3-384,384
                s172.2,384,384,384s384-172.3,384-384S723.8,128,512,128z"/>
          </svg>
        );
        break;
      case "warning":
        icon = (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path fill="currentColor" d="M512 165c29 2 54 19 67 45l303 533c9 14 13 31 14 48 0 19-8 37-23 50-17 12-38 18-59 18H210c-21 0-42-6-59-18-14-13-23-31-23-50 1-17
            5-34 14-48l303-533c13-26 38-43 67-45zm0 43c-10 0-21 8-29 23L179 764c-5 8-8 17-8 27-1 6 2 12 7 16 9 7 20 10 32 9h604c12
            1 23-2 32-9 5-3 8-9 7-16 0-9-3-19-8-27L541 232c-8-16-19-24-29-24zm-18 404c-5-5-8-12-7-19l-10-196c0-10 3-18 10-25 13-14 36-14 50 0 7 6 11 15 10 25l-10 196c1
             7-2 14-7 19-5 4-12 6-18 6-6 1-13-2-18-6zm18 61c10 0 20 4 28 12 8 6 12 16 12 27s-4 22-12 29-17 11-28 11c-10 0-20-4-28-11-15-15-15-41 0-56 8-8 18-12 28-12z"/>
            </svg>
        );
        break;
      case "error":
        icon = (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path fill="currentColor" d="M512 128c212 0 384 172 384 384S724 896 512 896 128 724 128 512s172-384 384-384zm143 497L542 512l113-113c8-8 8-22 0-30s-22-8-30 0L512
            482 399 369c-8-8-22-8-30 0s-8 22 0 30l113 113-113 113-1 1c-8 8-7 21 1 29l1 1c8 8 21 7 29-1l113-113 113 113 1 1c8 8 21 7 29-1l1-1c8-8 7-21-1-29z"/>
          </svg>
        );
        break;      
      default:
        icon = null
        break;
    }

    return (
      <NotificationContainer>
        <NotificationWrapper type={type}>
          <IconContainer>
          {icon}
          </IconContainer>
          <TextContainer>
          {text}
          </TextContainer>
          <ButtonsWrapper>
          {buttonElement && buttonElement()}
          <IconWrapper onClick={() => hideNotification()}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
            <path fill="currentColor" d="M590.3,512l290.2,290.2c20.5,20.5,20.5,56.5,0,77.1c-12.8,10.3-25.7,15.4-38.5,15.4c-15.4,0-28.3-5.1-41.1-15.4L513.3,589.1  L223,879.3c-12.8,10.3-25.7,15.4-38.5,15.4c-15.4,0-28.3-5.1-41.1-15.4c-20.5-20.5-20.5-56.5,0-77.1L433.7,512L143.4,221.8  c-20.5-20.5-20.5-56.5,0-77.1c23.1-20.5,56.5-20.5,79.6,0l290.2,287.7L801,144.7c23.1-20.5,56.5-20.5,79.6,0  c20.5,20.5,20.5,56.5,0,77.1L590.3,512z"/>
          </svg>
          </IconWrapper>
        </ButtonsWrapper>
        </NotificationWrapper>
      </NotificationContainer>
    );
  }
}

export default CustomNotification;


